import { defineStore } from 'pinia';
import useStore from '@/store';
import { ref } from 'vue';
import { Livestream } from '@/entities';

export default defineStore('livestream', () => {
  const rootStore = useStore();
  const livestreams = ref<Livestream[]>([]);
  const pastLivestreams = ref<Livestream[]>([]);
  const selectedLivestream = ref<Livestream | null>(null);
  const isLoading = ref(false);

  return {
    livestreams,
    pastLivestreams,
    selectedLivestream,
    isLoading,

    async init() {},
    async getLivestreams() {
      const cmsLocale = rootStore.user.cmsLocale;
      const data = await rootStore.apiService.livestream.fetchLivestreams(cmsLocale);

      if (data) {
        livestreams.value = data.map((livestreamData) => new Livestream(livestreamData));
      }
    },
    async getPastLivestreams() {
      isLoading.value = true;

      const cmsLocale = rootStore.user.cmsLocale;
      const data = await rootStore.apiService.livestream.fetchPastLivestreams(cmsLocale);

      if (data) {
        pastLivestreams.value = data.map((livestreamData) => new Livestream(livestreamData));
      }

      isLoading.value = false;
    },
    async selectLivestream(livestreamId?: string) {
      if (!livestreamId) {
        selectedLivestream.value = null;
      } else {
        selectedLivestream.value =
          livestreams.value.find((livestream) => livestream.id === livestreamId) ||
          pastLivestreams.value.find((livestream) => livestream.id === livestreamId) ||
          null;
      }
    }
  };
});
